// Camera capture helper. v0 uses <input type="file" capture="environment">
// which on iOS Safari / Android Chrome launches the system camera app and
// returns a File when the user hits Use Photo. On desktop browsers it falls
// back to a file picker (which is fine for dev).
//
// We explicitly do NOT use getUserMedia here. On iOS Safari it requires
// https (fine), but the built-in camera UI gives better results on tiny
// rating-plate labels (autofocus, torch, zoom), and respects "Take Photo"
// vs "Photo Library" affordances users already understand.

export function createCaptureInput({ onPick }) {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  input.capture = 'environment';
  input.className = 'hidden';
  input.addEventListener('change', () => {
    const file = input.files?.[0];
    if (file) onPick(file);
    input.value = '';
  });
  return input;
}

export function fileToObjectURL(file) {
  return URL.createObjectURL(file);
}

export function revokeObjectURL(url) {
  if (url) URL.revokeObjectURL(url);
}
